/* eslint-disable no-extend-native */
import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import FilesTable from './FilesTable'
import { getFiles, getUsers } from '../../utils/api'
import { ColoredLine } from '../elements/ColoredLine'
import makeAnimated from 'react-select/animated';
import { checkUserToken, CheckUserToken } from '../../utils/checkUser'

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas, faShareSquare } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faShareSquare)
const animatedComponents = makeAnimated();
const Files = () => {

    const [files, setFiles] = useState([]);
    const [users, setUsers] = useState([]);

    const [filesVisible, setFilesVisible] = useState([]);
    const [searchText, setSearchText] = useState("");

    useEffect(() => { 
        getUsers(setUsers);
        getFiles(setFiles);
        checkUserToken();
    }, []);


    //Filter Level 1
    useEffect(() => {
        setFilesVisible(
            files.filter((f) => {
            return(
                f.name.toLowerCase().includes(searchText.toLowerCase().trim())
                )
            })
        )          
    }, [searchText, files]);

    return (
        <Container className="main-container" fluid>  



            <Row className='row-header'>
                <h2 className="page-header">Files</h2>    
            </Row>          
            <ColoredLine color="#DEDEDE" />


            
                <Row>
                    <h5 className="filter-headers">Search</h5>
                    <Col xs={9} sm={7} md={6}>
                        <Form.Control
                            onChange={(e) => setSearchText(e.target.value)}
                            className="mb-3"
                            type="text"
                            placeholder="Search name or description..."
                        />
                    </Col>
                </Row>
                <FilesTable 
                    files={filesVisible} 
                    users={users} 
                    />           

        </Container>
    )
}

export default Files